import { computed } from 'vue-demi';
import { use as fegoUse } from '@fegobull/webapi';

export function useFegoPageInfo() {
  const { useLang, usePageType } = fegoUse;
  const { langText, lang } = useLang();
  const { isPC } = usePageType();

  /** 英文 */
  const isEN = computed(() => langText === 'en-us');
  /** 繁体中文 */
  const isHant = computed(() => langText === 'zh-hk');
  /** 简体中文 */
  const isHans = computed(() => langText === 'zh-cn');

  const kls = computed(() => [
    isPC ? 'is-pc' : 'is-mobile',
    isEN.value ? 'is-en' : '',
    isHant.value ? 'is-hant' : '',
    isHans.value ? 'is-hans' : '',
  ]);

  return {
    kls,
    isPC,
    isEN,
    isHant,
    isHans,
    lang,
  };
}
